<template>
    <div class="space-y-2">
        <MeetingDetailsSectionTitle iconName="font">
            Custom Fields
        </MeetingDetailsSectionTitle>
        <div class="space-y-4">
            <div v-for="customFieldResponseData in customFieldResponsesData">
                <div
                    class="text-xs font-semibold uppercase text-gray-500 cursor-auto"
                    @click.stop
                >
                    {{ customFieldResponseData.customField.title }}
                    <span
                        v-if="
                            customFieldResponseData.response.snapshotIsRequired
                        "
                        class="text-red-500"
                    >
                        *
                    </span>
                </div>
                <span
                    v-if="customFieldResponseData.response.isNotEmpty()"
                    class="cursor-auto"
                    @click.stop
                >
                    {{ customFieldResponseData.response.content }}
                </span>
                <span
                    v-else
                    class="cursor-auto text-gray-400"
                    @click.stop
                >
                    (empty)
                </span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import CustomFieldResponseData from '@/App/CustomField/Entity/CustomFieldResponseData'
    import MeetingDetailsSectionTitle from '@/App/Booking/Meeting/Component/MeetingDetailsSectionTitle.vue'

    const props = defineProps({
        customFieldResponsesData: {
            type: Object as PropType<CustomFieldResponseData[]>,
            required: true,
        },
    })
</script>
